export default class Pagination {
    constructor(page, size){
        this.page = page;
        this.size = size;
    }
    toString() {
        return `page=${this.page}&size=${this.size}`
    }
}